// app/javascript/controllers/guest_actions_controller.js
import { Controller } from "@hotwired/stimulus"
import { freshSession, signInForPartySetup } from './support/party_setup_request'

export default class extends Controller {
    static values = {
        sendUrl: String,
        deleteUrl: String,
        editUrl: String
    }

    confirmSend(e) {
        e.preventDefault()
        this.#swal({
            title: "Send invitation?",
            text: "We’ll email this guest their RSVP link.",
            icon: "question",
            confirmButtonText: "Send now",
            confirmButtonColor: "#004770"
        }).then((r) => {
            if (r.isConfirmed) this.#post(this.sendUrlValue)
        })
    }

    confirmDelete(e) {
        e.preventDefault()
        this.#swal({
            title: "Remove this guest?",
            text: "You can always add them back later.",
            icon: "warning",
            confirmButtonText: "Delete",
            confirmButtonColor: "#d33",
            showCancelButton: true
        }).then((r) => {
            if (r.isConfirmed) this.#del(this.deleteUrlValue)
        })
    }

    // --- helpers ---
    #csrf() {
        return document.querySelector('meta[name="csrf-token"]')?.content || ""
    }

    async #post(url) {
        if (this.sending) return
        this.sending = true
        let attempted = false
        try {
            let session = await freshSession()
            if (!session.authenticated) {
                if (!await signInForPartySetup(Swal)) return
                session = await freshSession()
                if (!session.authenticated) throw new Error('Sign in is required.')
            }
            attempted = true
            const response = await fetch(url, {
                method: "POST", credentials: 'same-origin', redirect: 'error',
                headers: { "Accept": "text/vnd.turbo-stream.html", "X-CSRF-Token": session.csrf_token }
            })
            if (!response.ok || !response.headers.get('Content-Type')?.includes('text/vnd.turbo-stream.html')) {
                throw new Error('Invitation response unavailable.')
            }
            Turbo.renderStreamMessage(await response.text())
        } catch (_) {
            // A lost response may follow a successful email send. Do not retry it.
            Swal.fire({ icon: 'error', title: attempted ? 'Couldn’t confirm the invitation was sent' : 'Couldn’t reconnect',
                text: attempted ? 'Check this guest’s invitation status before sending again.' : 'The invitation has not been sent. Please try again.' })
        } finally {
            this.sending = false
        }
    }

    #del(url) {
        fetch(url, {
            method: "DELETE",
            headers: { "Accept": "text/vnd.turbo-stream.html", "X-CSRF-Token": this.#csrf() }
        }).then(r => r.text()).then(html => Turbo.renderStreamMessage(html))
    }

    #swal(opts) {
        // uses your existing swal controller styles (global Swal)
        return Swal.fire(Object.assign({
            showCancelButton: true,
            cancelButtonText: "Cancel",
            reverseButtons: true
        }, opts))
    }
}
